import React, { useReducer, useEffect, useState } from "react";
import { MeleeSearchContext } from "../../utils/stateHandlers/contexts";
import { Link as DomLink, useLocation } from "react-router-dom";
import states from "../../utils/stateHandlers/initialStates";
import { meleeReducer } from "../../utils/stateHandlers/reducers";
import api from "../../utils/api";
import Modal from "./controls/Modal";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import constants, {
  hiddenColumns,
  hiddenMeleeMobile,
  hiddenTablet,
} from "../../utils/constants";
import { storage } from "../../utils";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import _ from "lodash";
import MeleeDiamondTable from "./MeleeDiamondTable";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import { Select as MUISelect } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MeleeDiamondSearchFilters from "./MeleeDiamondSearchFilters";
import MeleeAddToCartPreview from "./MeleeAddToCartPreview";
import { Default, Mobile } from "../../utils/deviceHelpers";

export default function MeleeDiamondSearchLanding(props) {
  const [meleeState, meleeSearchDispatch] = useReducer(
    meleeReducer,
    states.initialMeleeSearchState
  );
  const {
    pageLoaded,
    searchQuery,
    resultsLoaded,
    diamondCount,
    standard,
    strapiBody,
    strapiImage,
    openCartPreview,
  } = meleeState;
  const loggedIn = storage.getStorageItem("authToken") ? true : false;
  const [showContactModal, setShowContactModal] = useState(false);
  const sendTo = useLocation();

  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  const StandardOrUnique = () => (
    <Grid container>
      <Grid item className="mined-filter" sx={{ width: "100%" }}>
        <Button
          disableElevation
          variant="contained"
          color={standard === true ? "primary" : "secondary"}
          onClick={() => {
            meleeSearchDispatch({ type: "setStandardFlag", payload: true });
          }}
        >
          Standard
        </Button>
        <Button
          disableElevation
          variant="contained"
          color={standard === false ? "primary" : "secondary"}
          onClick={() => {
            meleeSearchDispatch({ type: "setStandardFlag", payload: false });
          }}
        >
          Unique Lots
        </Button>
      </Grid>
    </Grid>
  );

  function resetFilters() {
    meleeSearchDispatch({
      type: "clearFilters",
      payload: [],
    });
  }

  function nextPage() {
    const currentPage = searchQuery.page;
    meleeSearchDispatch({ type: "updatePage", payload: currentPage + 1 });
  }

  function prevPage() {
    const currentPage = searchQuery.page;
    meleeSearchDispatch({ type: "updatePage", payload: currentPage - 1 });
  }

  function formatCollectionsValues(resetCollections) {
    const formattedSignatureCollections = [];
    _.map(resetCollections.Signature, function (collection) {
      const newCollection = {
        value: collection,
        label: collection,
        selected: false,
      };
      formattedSignatureCollections.push(newCollection);
    });
    const formattedCanadianCollections = [];
    _.map(resetCollections["Canadian Origin"], function (collection) {
      const newCollection = {
        value: collection,
        label: collection,
        selected: false,
      };
      formattedCanadianCollections.push(newCollection);
    });
    const formattedHarmonyCollections = [];
    _.map(resetCollections.Harmony, function (collection) {
      const newCollection = {
        value: collection,
        label: collection,
        selected: false,
      };
      formattedHarmonyCollections.push(newCollection);
    });
    const formattedLabCollections = [];
    _.map(resetCollections["Harmony Lab Grown"], function (collection) {
      const newCollection = {
        value: collection,
        label: collection,
        selected: false,
      };
      formattedLabCollections.push(newCollection);
    });
    const formattedCollections = {
      Signature: formattedSignatureCollections,
      Canadian: formattedCanadianCollections,
      Harmony: formattedHarmonyCollections,
      Lab: formattedLabCollections,
    };
    return formattedCollections;
  }

  useEffect(() => {
    const query = qs.stringify({
      populate: {
        title: {
          populate: "*",
        },
        body: {
          populate: "*",
        },
        image: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/diamonds-unique-lots-page?${query}`).then((response) => {
      meleeSearchDispatch({
        type: "setStrapiInfo",
        payload: {
          body: response.data.data.attributes.body,
          image: response.data.data.attributes.image,
        },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.fetch("melee/fields").then((response) => {
      const standard = _.filter(response.data, function (field) {
        return field.search_order && field.name !== "Quality";
      });
      const collection = _.find(response.data, function (field) {
        return field.name === "Collection";
      });
      const newCollections = formatCollectionsValues(collection.values);
      const headers = _.filter(response.data, function (field) {
        return field.results_order && !hiddenColumns.includes(field.name);
      });
      const sortedHeaders = _.sortBy(headers, function (header) {
        return header.results_order;
      });
      const mobileHeaders = _.filter(sortedHeaders, function (header) {
        return !hiddenMeleeMobile.includes(header.name);
      });
      const tabletHeaders = _.filter(sortedHeaders, function (header) {
        return !hiddenTablet.includes(header.name);
      });
      meleeSearchDispatch({ type: "setFilters", payload: standard });
      meleeSearchDispatch({
        type: "setCollections",
        payload: newCollections,
      });
      meleeSearchDispatch({
        type: "setTableHeaders",
        payload: {
          tableHeaders: sortedHeaders,
          mobileTableHeaders: mobileHeaders,
          tabletTableHeaders: tabletHeaders,
        },
      });
      meleeSearchDispatch({ type: "pageLoaded", payload: true });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    meleeSearchDispatch({ type: "resultsLoaded", payload: false });
    api.post("melee/search", searchQuery).then((response) => {
      const collection = _.find(response.data.fields, function (field) {
        return field.name === "Collection";
      });
      const newCollections = formatCollectionsValues(collection.values);
      meleeSearchDispatch({
        type: "setCollections",
        payload: newCollections,
      });
      meleeSearchDispatch({
        type: "setResults",
        payload: {
          diamonds: response.data.results,
          diamondCount: response.data.count,
        },
      });
      meleeSearchDispatch({ type: "resultsLoaded", payload: true });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <MeleeSearchContext.Provider value={{ meleeState, meleeSearchDispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Stack spacing={1}>
          <Grid container direction="row" justifyContent="center">
            <Typography
              variant="h1"
              textAlign="center"
              sx={{ marginRight: "unset", marginBottom: "2rem" }}
            >
              Melee Diamond Search
            </Typography>
          </Grid>
          <Default>{StandardOrUnique()}</Default>

          <Grid container direction="row" justifyContent="center">
            <Typography>
              Need help finding the perfect diamond? &nbsp;
              <span
                className="contact-us cursor-pointer"
                onClick={() => setShowContactModal(true)}
              >
                Contact Us
              </span>
            </Typography>
          </Grid>
          <Mobile>{StandardOrUnique()}</Mobile>
          {standard ? (
            <Stack spacing={2}>
              <Container maxWidth="xl">
                <MeleeDiamondSearchFilters />
              </Container>
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="h3">Results ({diamondCount})</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body3" className="float-right">
                    <Stack direction="row" spacing={2}>
                      <Chip
                        color="warning"
                        label="Reset Filters"
                        onClick={() => resetFilters()}
                      />
                      {!loggedIn && (
                        <DomLink
                          to={{
                            pathname: "/login",
                            state: { sendTo: sendTo.pathname },
                          }}
                        >
                          <Button
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ marginTop: "unset" }}
                          >
                            Login For pricing
                          </Button>
                        </DomLink>
                      )}
                    </Stack>
                  </Typography>
                </Grid>
              </Grid>
              {!resultsLoaded ? (
                <Typography variant="h1" sx={{ width: "100%" }}>
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </Typography>
              ) : (
                <MeleeDiamondTable loggedIn={loggedIn} />
              )}
              <div>
                <Stack
                  direction="row"
                  alignItems="center"
                  className="float-right"
                  spacing={3}
                  sx={{ marginTop: "0.5rem" }}
                >
                  {searchQuery.page > 1 && (
                    <ChevronLeftIcon
                      onClick={() => prevPage()}
                      className="cursor-pointer"
                    />
                  )}
                  <Typography variant="body3">
                    Page {searchQuery.page}
                  </Typography>
                  {diamondCount > searchQuery.page * searchQuery.size && (
                    <ChevronRightIcon
                      onClick={() => nextPage()}
                      className="cursor-pointer"
                    />
                  )}
                  <Divider orientation="vertical" flexItem />
                  <Typography variant="body3">Results Per Page: </Typography>
                  <MUISelect
                    size="small"
                    value={searchQuery.size}
                    onChange={(event) =>
                      meleeSearchDispatch({
                        type: "updateSize",
                        payload: event.target.value,
                      })
                    }
                  >
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </MUISelect>
                  <Divider orientation="vertical" flexItem />
                </Stack>
              </div>
            </Stack>
          ) : (
            <Grid container justifyContent="center">
              <Box width="75%">
                <Paper variant="outlined" square>
                  <Stack justifyContent="center" spacing={2}>
                    <Typography
                      variant="subtitle1"
                      align="center"
                      sx={{
                        paddingLeft: "30rem",
                        paddingRight: "30rem",
                        paddingTop: "5rem",
                      }}
                    >
                      <ReactMarkdown remarkGfm={[remarkGfm]}>
                        {strapiBody}
                      </ReactMarkdown>
                    </Typography>
                    <a
                      href={strapiImage.data.attributes.alternativeText}
                      target="_blank"
                      rel="noreferrer"
                      className="center"
                    >
                      <img
                        src={`${frontImageUrl}${strapiImage.data.attributes.url}`}
                        alt={strapiImage.title}
                      />
                    </a>
                  </Stack>
                </Paper>
              </Box>
            </Grid>
          )}
        </Stack>
      )}
      <Modal
        title="Contact Us"
        onClose={() => setShowContactModal(false)}
        show={showContactModal}
      />
      {openCartPreview && <MeleeAddToCartPreview />}
    </MeleeSearchContext.Provider>
  );
}
